import {
  deleteReport,
  deleteReportsSchedule,
  downloadReport,
  downloadReportGroup,
  generatePopularReport,
  getPopularReports,
  getReportCreators,
  getReportPreferences,
  getReports,
  getReportsSchedule,
  newReport,
  patchReport,
  patchReportsSchedule,
  postReportsSchedule,
  saveReportPreferences,
  schedulePopularReport,
} from 'services/reports';
import {
  IGetReportsParams,
  IGetReportsResponse,
  IGetReportsScheduleResponse,
  INewReportParams,
  IReport,
  IReportCreator,
  IReportDL,
  IPopularReport,
  IReportPreferencesResponse,
  IReportSchedule,
  IReportSchedulePayload,
  IPopularReportCreationInfo,
} from './types';

export const getReportsAction = async (params: IGetReportsParams): Promise<IGetReportsResponse> => {
  const { data } = await getReports(params);
  return {
    results: data.results,
    count: data.count,
  };
};

export const newReportAction = async (params: INewReportParams): Promise<{ result: IReport }> => {
  const { data } = await newReport(params);
  return {
    result: data,
  };
};

export const downloadReportAction = async (id: string): Promise<{ result: IReportDL }> => {
  const { data } = await downloadReport(id);
  return {
    result: data,
  };
};

export const downloadReportGroupAction = async (id: string): Promise<{ result: IReportDL }> => {
  const { data } = await downloadReportGroup(id);
  return {
    result: data,
  };
};

export const getReportSelectionPreferences = async (
  reportType?: string
): Promise<{ results: IReportPreferencesResponse[] }> => {
  const { data } = await getReportPreferences(reportType);
  return {
    results: data.results,
  };
};

export const saveReportSelectionPreferences = async (
  checkboxes: string[],
  reportType: string
): Promise<IReportPreferencesResponse> => {
  const { data } = await saveReportPreferences(checkboxes, reportType);
  return data;
};

export const getReportsScheduleAction = async (params: {
  ordering?: string;
  frequency?: string;
  page?: number;
  page_size?: number;
  search?: string;
}): Promise<IGetReportsScheduleResponse> => {
  const { data } = await getReportsSchedule(params);
  return data;
};

export const patchReportScheduleAction = async (
  id: string,
  payload: Partial<IReportSchedule>
): Promise<IGetReportsScheduleResponse> => {
  const { data } = await patchReportsSchedule(id, payload);
  return data;
};

export const postReportScheduleAction = async (
  payload: IReportSchedulePayload
): Promise<IGetReportsScheduleResponse> => {
  const { data } = await postReportsSchedule(payload);
  return data;
};

export const deleteReportScheduleAction = async (id: string): Promise<void> => {
  await deleteReportsSchedule(id);
};

export const patchReportAction = async (
  id: string,
  payload: Partial<IReport>
): Promise<IReport> => {
  const { data } = await patchReport(id, payload);
  return data;
};

export const deleteReportAction = async (id: string): Promise<void> => {
  await deleteReport(id);
};

export const getReportCreatorsAction = async (): Promise<IReportCreator[]> => {
  const { data } = await getReportCreators();
  return data;
};

export const getPopularReportsAction = async (): Promise<IPopularReport[]> => {
  const { data } = await getPopularReports();
  return data.results;
};

export const generatePopularReportsAction = async (params: {
  popular_report_id: string;
  from_date: string;
  to_date: string;
  uaa_ids?: string[];
  team_ids?: string[];
}): Promise<IPopularReportCreationInfo> => {
  const { data } = await generatePopularReport(params);
  return data;
};

export const schedulePopularReportsAction = async (
  frequency: string[],
  reportId: string
): Promise<void> => {
  await schedulePopularReport(frequency, reportId);
};
